module.exports = __webpack_public_path__ + "img/expert-opinion-placeholder.c85c86bf.svg";